<template>
  <section class="app-overview">
    <div class="app-overview__description">
      <p>{{ currentApp.longDescription }}</p>
    </div>
    <div class="app-overview__images-container" v-if="currentApp.images && currentApp.images.length > 0">
      <div
        class="app-overview__image-container"
        v-for="(image, index) in currentApp.images"
        :key="`${currentApp.id}-image-${index}`"
      >
        <img class="app-overview__image" :src="image" :alt="`${currentApp.name} screenshot`" />
      </div>
    </div>
    <div class="app-overview__video-container" v-if="currentApp.video">
      <iframe :src="currentApp.video" title="Video player" frameborder="0" allowfullscreen></iframe>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();
const currentApp = computed(() => store.getters.currentApp);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.app-overview {
  &__images-container {
    img {
      max-width: 100%;
      margin: 1rem auto 0;
    }
  }
  &__video-container {
    margin-top: 1rem;
    position: relative;
    height: 420px;
    width: 100%;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
